import * as React from 'react';

import classNames from 'classnames';

import type { ActionType } from 'bundles/widget-simulator/types';

import 'css!./__styles__/RpcActionType';

type Props = {
  type: ActionType;
};

const RpcActionType = ({ type }: Props) => <span className={classNames('rc-RpcActionType', type)}>{type}</span>;

export default RpcActionType;
